import React from "react";
import { Button } from "antd";
import Swal from "sweetalert2";
import APIService from "../../Service/APIService.js";
import CommonButton from "../../common/button/button.js";
import "./AdminTools.css";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../AuthProvider.js";

const TissueVaultToHubspotSync = () => {
  const navigate = useNavigate();
  const { user, isReady } = useAuth();

  React.useEffect(() => {
    const userData = user;
    if (userData?.Type !== "Admin") {
      navigate("/");
      // window.location.reload();
    }
    if (userData?.Type === "Admin" && !userData?.IsSuperAdmin) {
      navigate("/");
      // window.location.reload();
    }
  }, []);

  const runHubspotSync = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "This will sync data from Hubspot into Tissue Vault. This process may take several minutes. You will receive an email when the sync is completed.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "var(--primaryColor)",
      cancelButtonColor: "var(--failureColorDark)",
      confirmButtonText: "Proceed",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const apiServe = new APIService();
        const response = await apiServe.addDataToBackend({}, "runhubspotsync?limit=25000");

        if (response?.status === 200) {
          Swal.fire("Sync Started!", "The Hubspot sync has been initiated successfully.", "success");
        } else {
          Swal.fire("Error!", "There was an error initiating the Hubspot sync. Please try again or contact support.", "error");
        }
      }
    });
  };

  const runHubspotStop = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "This will stop the ongoing sync from Hubspot to Tissue Vault.",
      icon: "warning",
      showCancelButton: false,
      confirmButtonColor: "var(--failureColorDark)",
      cancelButtonColor: "var(--failureColorDark)",
      confirmButtonText: "Stop Sync",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const apiServe = new APIService();
        const response = await apiServe.addDataToBackend({}, "stophubspotsync");

        if (response?.status === 200) {
          Swal.fire("Sync Stopped!", "The Hubspot sync has been stopped successfully.", "success");
        } else {
          Swal.fire("Error!", "There was an error stopping the Hubspot sync.", "error");
        }
      }
    });
  };

  const runHubspotRevert = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "This will revert the last sync from Hubspot to Tissue Vault. This process may take several minutes.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "var(--primaryColor)",
      cancelButtonColor: "var(--failureColorDark)",
      confirmButtonText: "Proceed",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const apiServe = new APIService();
        const response = await apiServe.addDataToBackend({}, "reverthubspotsync");

        if (response?.status === 200) {
          Swal.fire("Revert Started!", "The Hubspot revert has been initiated successfully.", "success");
        } else {
          Swal.fire("Error!", "There was an error initiating the Hubspot revert.", "error");
        }
      }
    });
  };

  return (
    <div className="admin-tools-wrapper">
      <div className="text text-h1">Tissue Vault → Hubspot Sync</div>
      <div className="text text-smallText admin-tools-subtitle">
        Manually control Hubspot data synchronization operations.
      </div>

      <div className="spacer-24" />

      <div className="hubspot-sync-actions">
        <CommonButton class="button-primary" onClick={runHubspotSync}>
          Run TV to Hubspot Sync
        </CommonButton>

        <CommonButton class="button button-table button-table-failure" onClick={runHubspotStop}>
          Stop Sync
        </CommonButton>

        <CommonButton class="button button-table button-table-warning" onClick={runHubspotRevert}>
          Revert Sync
        </CommonButton>
      </div>
    </div>
  );
};

export default TissueVaultToHubspotSync;